import React, { FC, ReactElement, useState } from "react";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import WizardSideBarStep from "../../models/WizardSideBarStep";
import Wizard from "../wizard/wizard";
import { Summary } from "./date-filter/summary-step";

interface StaticFilterWizardProps {
    defaultContent: ReactElement[];
    defaultSteps: WizardSideBarStep[];
    onClose: () => void;
    onBack: (event: any) => void;
    selectedCategory: string;
    filterTypeName: string;
}

const StaticFilterWizard: FC<StaticFilterWizardProps> = ({defaultContent, defaultSteps, onClose, onBack, selectedCategory, filterTypeName}) => {
    const { translate } = useLocale();
    const [step] = useState<number>(2);
    
    const content: ReactElement[] = [
        ...defaultContent,
        <Summary
            key={"wizard-4"}
            onBack={onBack}
            type={filterTypeName}
            category={selectedCategory} />
    ]

    const steps: WizardSideBarStep[] = [
        ...defaultSteps,
        {
            title: translate.byKey(TranslationKeys.summary),
            description: '',
            substeps: []
        }
    ];

    return <Wizard name={translate.byKey(TranslationKeys.dataFilters)}
        step={step}
        onClose={() => onClose()}
        sidebarSteps={steps}>
        {content}
    </Wizard>
}

export default StaticFilterWizard;